import React, { useEffect } from "react";
import { getText } from "../utils";
import "./index.less";

export default (
  props: IMultiElementCombineMsg.ITipData & { children: any }
): JSX.Element | null => {
  const {
    id,
    isEmpty,
    required,
    required_tips,
    prompt_tips,
    isLeftGap,
    relationTip,
    setSubmitState,
  } = props;

  const isShowRequiredTip = isEmpty && required;
  const requiredTip = isShowRequiredTip && getText(required_tips);
  const promptTip = getText(prompt_tips);
  const tip = relationTip || requiredTip || promptTip;

  useEffect(() => {
    setSubmitState &&
      setSubmitState({ id, isTip: !!(relationTip || isShowRequiredTip) });
  }, [relationTip, isShowRequiredTip]);

  const tipInfo = tip ? (
    <span
      className={`sscard_tips ${isLeftGap ? "sscard_lefGap" : ""} ${
        relationTip || requiredTip ? "sscard_redTip" : ""
      }`}
    >
      {tip}
    </span>
  ) : null;

  return (
    <>
      {props.children}
      {tipInfo}
    </>
  );
};
